// @flow

import { SimpleEntity } from '../abstract/SimpleEntity';
import type { EntityFieldCollection } from '../types';
import { idField } from '../abstract/StoredEntity';

class OrderedItem implements SimpleEntity {
    static fields: EntityFieldCollection = {
        id: idField,
        name: {
            displayName: 'Name',
            recordName: 'name',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
        price: {
            displayName: 'Price',
            recordName: 'price',
            dataType: {
                primitive: 'amt',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
        quantity: {
            displayName: 'Quantity',
            recordName: 'quantity',
            dataType: {
                primitive: 'num',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
        total: {
            displayName: 'Total',
            recordName: 'total',
            dataType: {
                primitive: 'amt',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
    };

    constructor(record: any) {
        this.record = record;
    }
}

export default OrderedItem;
